import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg } from 'utils';

export const MEDIA_FETCH_DATA_INIT = createAction('MEDIA_FETCH_DATA_INIT');
export const MEDIA_FETCH_DATA_SUCCESS = createAction(
  'MEDIA_FETCH_DATA_SUCCESS'
);
export const MEDIA_FETCH_DATA_FAIL = createAction('MEDIA_FETCH_DATA_FAIL');

export const MEDIA_DELETE_MEDIA_INIT = createAction('MEDIA_DELETE_MEDIA_INIT');
export const MEDIA_DELETE_MEDIA_SUCCESS = createAction(
  'MEDIA_DELETE_MEDIA_SUCCESS'
);
export const MEDIA_DELETE_MEDIA_FAIL = createAction('MEDIA_DELETE_MEDIA_FAIL');

export const BULK_MEDIA_DELETE_INIT = createAction('BULK_MEDIA_DELETE_INIT');
export const BULK_MEDIA_DELETE_SUCCESS = createAction(
  'BULK_MEDIA_DELETE_SUCCESS'
);
export const BULK_MEDIA_DELETE_FAIL = createAction('BULK_MEDIA_DELETE_FAIL');

export const MEDIA_CLEAR_DATA = createAction('MEDIA_CLEAR_DATA');

export const MEDIA_CREATE_MEDIA_INIT = createAction('MEDIA_CREATE_MEDIA_INIT');
export const MEDIA_CREATE_MEDIA_SUCCESS = createAction(
  'MEDIA_CREATE_MEDIA_SUCCESS'
);
export const MEDIA_CREATE_MEDIA_FAIL = createAction('MEDIA_CREATE_MEDIA_FAIL');

export const MEDIA_MODIFY_MEDIA_INIT = createAction('MEDIA_MODIFY_MEDIA_INIT');
export const MEDIA_MODIFY_MEDIA_SUCCESS = createAction(
  'MEDIA_MODIFY_MEDIA_SUCCESS'
);
export const MEDIA_MODIFY_MEDIA_FAIL = createAction('MEDIA_MODIFY_MEDIA_FAIL');

export const MEDIA_CLEAN_UP = createAction('MEDIA_CLEAN_UP');

export const MEDIA_CLEAR_DATA_LOGOUT = createAction('MEDIA_CLEAR_DATA_LOGOUT');

export const MEDIA_BULK = createAction('MEDIA_BULK');

// added by me
export const SET_MEDIA = createAction('SET_MEDIA');
export const ORDER_MEDIA = createAction('ORDER_MEDIA');
export const PASTE_MEDIA = createAction('PASTE_MEDIA');

export const MEDIA_ADD_MEDIA_GROUP = createAction('MEDIA_ADD_MEDIA_GROUP');

export const fetchMedia = ({
  mediaId,
  siteId,
  categoryId,
  type,
  start,
  end,
}) => {
  return async (dispatch, getState) => {
    dispatch(MEDIA_FETCH_DATA_INIT());
    if (mediaId) {
      let mediaData;
      try {
        mediaData = await Axios.get(`${url}/media/get`, {
          params: {
            id: mediaId,
            siteId,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(MEDIA_FETCH_DATA_FAIL({ error }));
      }
      const media = {
        ...mediaData.data.data,
        id: mediaId,
        categoryList: [
          {
            label: mediaData.data.data?.categoryName,
            value: mediaData.data.data?.categoryId,
          },
        ],
      };
      return dispatch(
        MEDIA_FETCH_DATA_SUCCESS({
          list: getState().media.list,
          media,
          categoryId,
        })
      );
    }

    if (siteId) {
      let media;
      try {
        const payload = { siteId, categoryId, type };

        // Add start and end dates to the payload if provided
        if (start) payload.start = start;
        if (end) payload.end = end;
        media = await Axios.post(`${url}/media/filter`, payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(MEDIA_FETCH_DATA_FAIL({ error }));
      }
      // media = media.data.data.filter((media) => media.siteId === siteId);
      return dispatch(
        MEDIA_FETCH_DATA_SUCCESS({
          list: media.data.data,
          media: getState().media.media,
          categoryId,
        })
      );
    }
    return null;
  };
};

export const bulkDeleteMedia = ({ siteId, data }, cb) => {
  return async (dispatch) => {
    dispatch(BULK_MEDIA_DELETE_INIT());

    try {
      await Axios.post(
        `${url}/media/bulk-delete`,
        {
          siteId,
          data,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        BULK_MEDIA_DELETE_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The media was deleted.');
    cb();
    return dispatch(BULK_MEDIA_DELETE_SUCCESS({ data }));
  };
};

export const removeMedia = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(MEDIA_DELETE_MEDIA_INIT());
    try {
      await Axios.post(
        `${url}/media/remove`,
        {
          id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        MEDIA_DELETE_MEDIA_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The media was removed.');
    cb();
    return dispatch(MEDIA_DELETE_MEDIA_SUCCESS({ id }));
  };
};

export const deleteMedia = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(MEDIA_DELETE_MEDIA_INIT());

    try {
      await Axios.delete(`${url}/media/delete`, {
        params: {
          id,
          siteId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        MEDIA_DELETE_MEDIA_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The media was deleted.');
    cb();
    return dispatch(MEDIA_DELETE_MEDIA_SUCCESS({ id }));
  };
};

export const clearMediaData = () => {
  return (dispatch) => {
    dispatch(MEDIA_CLEAR_DATA());
  };
};

export const clearMediaDataLogout = () => {
  return (dispatch) => {
    dispatch(MEDIA_CLEAR_DATA_LOGOUT());
  };
};

export const createMedia = (
  {
    name,
    description,
    start,
    end,
    duration,
    file,
    urllink,
    siteId,
    categoryId,
    associatedPois,
    schedulingType = 'manual',
    schedulingIds,
    tags,
    categoryName,
    type,
    days,
    dates,
    color,
    eventSchedule,
    categoryList,
  },
  cb
) => {
  return async (dispatch) => {
    dispatch(MEDIA_CREATE_MEDIA_INIT());

    const fd = new FormData();
    fd.set('path', 'media');
    fd.set('name', name);
    if (eventSchedule) fd.set('eventSchedule', eventSchedule);
    fd.set('description', description);
    if (start && end && start !== 'Invalid date' && end !== 'Invalid date') {
      fd.set('start', start);
      fd.set('end', end);
    }
    fd.set('duration', duration);
    fd.set('url', urllink);
    fd.set('siteId', siteId);
    if (categoryId) {
      fd.set('categoryId', categoryId);
      fd.set('categoryName', categoryName);
    }
    if (associatedPois) {
      fd.set('associatedPois', associatedPois);
      // fd.set('categoryName', categoryName);
    }
    fd.set('schedulingType', schedulingType);
    if (schedulingIds) fd.set('schedulingIds', JSON.stringify(schedulingIds));
    if (tags) {
      fd.set('tags', tags);
      // fd.set('categoryName', categoryName);
    }
    fd.set('dates', JSON.stringify(dates));
    fd.set('days', JSON.stringify(days));

    fd.set('type', type);
    fd.set('color', color);
    fd.set('categoryList', JSON.stringify(categoryList));
    fd.append('file', file);
    let createdMedia;
    try {
      createdMedia = await Axios.post(`${url}/mediaDirectory/upload`, fd, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
      log(createdMedia, '<<<< create mediaaa');
    } catch (error) {
      log(error.response, '<<<< error add media');

      toastr.error(
        '',
        error.response?.data?.message || 'Please fill in all required fields'
      );

      return dispatch(
        MEDIA_CREATE_MEDIA_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Media created successfully');
    if (cb) {
      cb();
    }
    return dispatch(
      MEDIA_CREATE_MEDIA_SUCCESS({ media: createdMedia.data.data })
    );
  };
};

export const modifyMedia = (
  {
    id,
    name,
    description,
    start,
    end,
    duration,
    categoryId,
    categoryName,
    schedulingType,
    schedulingIds,
    file,
    siteId,
    urllink,
    associatedPois,
    tags,
    eventSchedule,
    type,
    days,
    dates,
    color,
  },
  cb
) => {
  return async (dispatch) => {
    dispatch(MEDIA_MODIFY_MEDIA_INIT());
    log(categoryId, dates);
    const fd = new FormData();

    fd.set('path', 'media');
    fd.set('id', id);
    fd.set('name', name);
    fd.set('url', urllink);
    fd.set('description', description);
    if (start && end && start !== 'Invalid date' && end !== 'Invalid date') {
      fd.set('start', start);
      fd.set('end', end);
    }
    if (duration) {
      fd.set('duration', duration);
    }
    if (eventSchedule) {
      fd.set('eventSchedule', eventSchedule);
    }
    fd.set('siteId', siteId);
    if (categoryId) {
      fd.set('categoryId', categoryId);
    }
    fd.set('schedulingType', schedulingType);
    if (categoryName) {
      fd.set('categoryName', categoryName);
    }
    if (schedulingIds) fd.set('schedulingIds', JSON.stringify(schedulingIds));
    if (associatedPois) {
      fd.set('associatedPois', associatedPois);
    }
    if (tags) {
      fd.set('tags', tags);
    }
    fd.set('dates', JSON.stringify(dates));
    fd.set('days', JSON.stringify(days));
    fd.set('type', type);
    fd.set('color', color);
    fd.append('file', file);
    let updateMedia;
    log(fd.toString(), 'request body');

    try {
      updateMedia = await Axios.post(`${url}/media/edit`, fd, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        MEDIA_MODIFY_MEDIA_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Media updated successfully');
    if (cb) {
      cb();
    }

    return dispatch(
      MEDIA_MODIFY_MEDIA_SUCCESS({ media: updateMedia.data.data, id })
    );
  };
};

export const bulkMedia = ({ data, siteId }) => {
  log('Im called before dispatch');
  return async (dispatch) => {
    log('Im called after dispatch');
    const mediaBulkData = await Axios.post(
      `${url}/media/bulk`,
      {
        data,
        siteId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    return dispatch(MEDIA_BULK({ medias: mediaBulkData.data.data }));
  };
};

// added by me
export const setMedia = (media) => {
  return (dispatch) => {
    dispatch(SET_MEDIA({ media }));
  };
};

export const orderMedia = (media) => {
  return (dispatch) => {
    dispatch(ORDER_MEDIA({ media }));
  };
};

export const mediaCleanUp = () => (dispatch) => dispatch(MEDIA_CLEAN_UP());

export const mediaPaste = (
  { directoryList, siteId, categoryId, categoryName },
  cb
) => {
  return async () => {
    await Axios.post(
      `${url}/media/create`,
      {
        directoryList,
        siteId,
        categoryId,
        categoryName,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    cb();
  };
};

export const bulkUpdate = ({ start, end, ids, siteId }, cb) => {
  return async () => {
    await Axios.put(
      `${url}/media/bulk `,
      {
        start,
        end,
        ids,
        siteId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    cb();
  };
};

export const bulkApproval = ({ status, ids, siteId }, cb) => {
  return async () => {
    await Axios.post(
      `${url}/media/approval `,
      {
        status,
        ids,
        siteId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    cb();
  };
};

export const modifyMedia2 = (
  {
    id,
    name,
    description,
    start,
    end,
    duration,
    categoryId,
    categoryName,
    schedulingType,
    schedulingIds,
    file,
    siteId,
    urllink,
    associatedPois,
    tags,
    eventSchedule,
    type,
    days,
    dates,
    color,
    grouped = [],
    // group edit: media items whose category was unselected
    removedIds = [],
    // group edit: categories newly selected, [{ categoryId, categoryName }]
    addedCategories = [],
    // source directory entry, used to clone the media into a new category
    directoryId,
  },
  cb
) => {
  return async (dispatch) => {
    dispatch(MEDIA_MODIFY_MEDIA_INIT());

    const buildFormData = (media) => {
      const fd = new FormData();

      fd.set('path', 'media');
      fd.set('id', media.id);
      fd.set('name', media.name);
      fd.set('url', media.urllink);
      fd.set('description', media.description);

      if (
        media.start &&
        media.end &&
        media.start !== 'Invalid date' &&
        media.end !== 'Invalid date'
      ) {
        fd.set('start', media.start);
        fd.set('end', media.end);
      }

      if (media.duration) fd.set('duration', media.duration);
      if (media.eventSchedule) fd.set('eventSchedule', media.eventSchedule);

      fd.set('siteId', media.siteId);
      fd.set('schedulingType', media.schedulingType);

      if (media.categoryId) fd.set('categoryId', media.categoryId);
      if (media.categoryName) fd.set('categoryName', media.categoryName);
      if (media.schedulingIds)
        fd.set('schedulingIds', JSON.stringify(media.schedulingIds));
      if (media.associatedPois) fd.set('associatedPois', media.associatedPois);
      if (media.tags) fd.set('tags', media.tags);

      fd.set('dates', JSON.stringify(media.dates));
      fd.set('days', JSON.stringify(media.days));
      fd.set('type', media.type);
      fd.set('color', media.color);

      if (media.file) {
        fd.append('file', media.file);
      }

      return fd;
    };

    try {
      let responses = [];

      log('Grouped', grouped);

      const isGroupEdit =
        grouped.length > 0 ||
        removedIds.length > 0 ||
        addedCategories.length > 0;

      if (isGroupEdit) {
        responses = [];

        // template used for the categories added during this edit
        const groupBase = grouped[0] || {
          name,
          description,
          start,
          end,
          duration,
          schedulingType,
          schedulingIds,
          siteId,
          urllink,
          associatedPois,
          tags,
          eventSchedule,
          type,
          days,
          dates,
          color,
        };

        for (const item of grouped) {
          const res = await Axios.post(
            `${url}/media/edit`,
            buildFormData(item),
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                'content-type': 'multipart/form-data',
              },
            }
          );

          log('Response', res);

          responses.push(res);
        }

        if (addedCategories.length > 0 && directoryId) {
          for (const addedCategory of addedCategories) {
            const created = await Axios.post(
              `${url}/media/create`,
              {
                directoryList: [directoryId],
                siteId,
                categoryId: addedCategory.categoryId,
                categoryName: addedCategory.categoryName,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    'accessToken'
                  )}`,
                },
              }
            );

            const createdData = created?.data?.data;
            const createdList = Array.isArray(createdData)
              ? createdData
              : [createdData].filter(Boolean);

            // the clone inherits the directory defaults, apply the edited values
            for (const createdMedia of createdList) {
              const createdId = createdMedia._id || createdMedia.id;
              if (!createdId) continue;

              const res = await Axios.post(
                `${url}/media/edit`,
                buildFormData({
                  ...groupBase,
                  id: createdId,
                  categoryId: addedCategory.categoryId,
                  categoryName: addedCategory.categoryName,
                  file: undefined,
                }),
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                      'accessToken'
                    )}`,
                    'content-type': 'multipart/form-data',
                  },
                }
              );

              responses.push(res);
            }
          }
        }

        for (const removedId of removedIds) {
          await Axios.delete(`${url}/media/delete`, {
            params: {
              id: removedId,
              siteId,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          });
        }
      } else {
        const response = await Axios.post(
          `${url}/media/edit`,
          buildFormData({
            id,
            name,
            description,
            start,
            end,
            duration,
            categoryId,
            categoryName,
            schedulingType,
            schedulingIds,
            file,
            siteId,
            urllink,
            associatedPois,
            tags,
            eventSchedule,
            type,
            days,
            dates,
            color,
          }),
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'content-type': 'multipart/form-data',
            },
          }
        );
        responses = [response];
      }

      toastr.success('', 'Media updated successfully');

      if (typeof cb === 'function') {
        cb();
      }

      return dispatch(
        MEDIA_MODIFY_MEDIA_SUCCESS({
          media: responses.map((r) => r.data.data),
        })
      );
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ?? 'Failed to update media';

      toastr.error('', errorMessage);

      return dispatch(
        MEDIA_MODIFY_MEDIA_FAIL({
          error: error?.response?.data,
        })
      );
    }
  };
};

export const addMediaGroupToBeEdited = (mediaGroup, cb) => {
  return (dispatch) => {
    dispatch(MEDIA_ADD_MEDIA_GROUP({ mediaGroup }));
    cb();
  };
};
